import React from "react";
import "./CdPortal.css";
import "@leenguyen/react-flip-clock-countdown/dist/index.css";
import MobileScaleWrapper from "../../MobileScaleWrapper";

const CdPortal = () => {
  return (
    <MobileScaleWrapper gradientTop="#FFE2E2" gradientBottom="#ffc4c4">
      <div className="cd-portal"></div>
    </MobileScaleWrapper>
  );
};

export default CdPortal;
